import React from 'react'
import { Box, Typography, Grid } from '@mui/material'

const LeadMetaData = ({metaData,details}) => {
    const metaDataLeda = [
        { Title: 'IP Address', Name: metaData?.ipAddress || "-" },
        { Title: 'Device', Name: metaData?.device || "-" },
        { Title: 'Browser', Name: metaData?.browser || "-"},
        { Title: 'Referral URL', Name: metaData?.referralUrl || "-" },
        { Title: 'Page of Origin', Name: metaData?.pageUrl || "-" },
        { Title: 'Location', Name: `${details?.city ? `${details?.city},` : ""} ${details?.state || ""} ` },
    ];

    const half = Math.ceil(metaDataLeda.length / 2);
    const firstColumn = metaDataLeda.slice(0, half);
    const secondColumn = metaDataLeda.slice(half);

    return (
        <Box sx={{ background: '#fff', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', padding: '25px', borderRadius: '16px', marginBottom: '25px' }}>
            <Typography variant='h2' sx={{ color: '#1E1E1E',     fontSize: {xl: '24px !important' , lg: '17px !important'}, marginBottom: '35px', fontWeight: 500 }}>
                Lead Metadata
            </Typography>

            <Grid container spacing={2}>
                <Grid size={4}>
                    {firstColumn.map((item, index) => (
                        <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
                            <Typography sx={{ color: '#1E1E1E',    fontSize: {xl: '18px !important' , lg: '14px !important'}, fontWeight: 500 }}>
                                {item.Title}
                            </Typography>
                            <Typography sx={{ color: '#5A5A5A',textTransform:'capitalize', fontSize: {xl: '16px !important' , lg: '12px !important'}, fontWeight: 400 }}>
                                {item.Name}
                            </Typography>
                        </Box>
                    ))}
                </Grid>

                <Grid size={4}>
                   
                </Grid>
                <Grid size={4}>
                    {secondColumn.map((item, index) => (
                        <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
                             <Typography sx={{ color: '#1E1E1E',    fontSize: {xl: '18px !important' , lg: '14px !important'}, fontWeight: 500 }}>
                                {item.Title}
                            </Typography>
                            <Typography sx={{ color: '#5A5A5A',    fontSize: {xl: '16px !important' , lg: '12px !important'}, fontWeight: 400 }}>
                                {item.Name}
                            </Typography>
                        </Box>
                    ))}
                </Grid>
            </Grid>
        </Box>
    );
};

export default LeadMetaData;
